import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Header from "../Layout/Header";
import SideBar from "../Layout/SideBar";
import axios from "axios";
import { baseURL } from "../../axios/common";
import Skeleton from "react-loading-skeleton";

const ShowActivity = () => {
  const { activity_id } = useParams();
  const { user_id } = useParams();
  const { search } = useLocation();
  const [activityDetails, setActivityDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const urlParams = new URLSearchParams(search);
  const language = urlParams.get('language') || 'en';

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setError("No token found. Please log in.");
      setLoading(false);
      return;
    }

    if (!activity_id) {
      setError("Activity ID is missing.");
      setLoading(false);
      return;
    }

    axios
      .post(`${baseURL}admin/getActivityDetails`, {
        user_id,
        activity_id,
        language,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      })
      .then((response) => {
        setActivityDetails(response.data.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch activity details');
        setLoading(false);
      });
  }, [activity_id, user_id, language]);

  if (loading) {
    return (
      <div>
        <Header />
        <SideBar />
        <main>
          <div className="content-wrapper pt-5 changePassword">
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <h2>Activity Details</h2>
                      </div>
                      <div className="card-body">
                        <Skeleton width="100%" height={20} count={10} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  const styles = {
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)', 
      gap: '20px', 
      marginBottom: '20px', 
    },
    boxShadowCard: {
      padding: '10px', 
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      transition: 'box-shadow 0.3s ease',
      marginBottom: '25px', 
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    name: {
      fontWeight: 'bold',
      marginBottom: '5px', 
    },
    email: {
      color: '#555',
    },
    profileImage: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      marginRight: '10px',
    },
    requestItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      marginBottom: '10px',
    },
  };

  return (
    <>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper pt-5 changePassword">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-header">
                      <h2>Activity Details</h2>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Name</label>
                              <h6>{activityDetails.name}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Start Date</label>
                              <h6>{activityDetails.start_date}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Start Time</label>
                              <h6>{activityDetails.start_time}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Duration</label>
                              <h6>{activityDetails.duration} mins</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Location</label>
                              <h6>{activityDetails.location_text}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Participants allowed</label>
                              <h6>{activityDetails.number_of_person}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Rating</label>
                              <h6>{activityDetails.rating}</h6>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Creator</label>
                              <div style={styles.textContainer}>
                                <img
                                  src={`${baseURL}${activityDetails.creator.profile_path}`}
                                  alt="Creator Profile"
                                  style={{ width: 50, height: 50, borderRadius: '50%' }}
                                />
                                <h6>{activityDetails.creator.name}</h6>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="col-md-4" style={styles.boxShadowCard}>
                          {loading ? (
                            <Skeleton width="100%" height={20} />
                          ) : (
                            <>
                              <label>Sport Name</label>
                              <div style={styles.textContainer}>
                                <img
                                  src={`${baseURL}${activityDetails.sport.icon_path}`}
                                  alt="Sport Icon"
                                  style={{ width: 30, height: 30 }}
                                />
                                <h6>{activityDetails.sport.name}</h6>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label> </label>
                          <ul style={styles.gridContainer}>
                            {activityDetails.requests.map((request) => (
                              <li key={request.id} style={{ listStyleType: 'none' }}>
                                <div style={styles.requestItem}>
                                  <div style={styles.textContainer}>
                                    <span style={styles.name}>{request.name} </span>
                                    <span style={styles.email}>({request.email})</span>
                                  </div>
                                  <img
                                    src={request.profile_path ? `${baseURL}${request.profile_path}` : 'default_profile.png'}
                                    alt={request.name}
                                    style={styles.profileImage}
                                  />
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ShowActivity;
